import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.cpt-slider' ).length ) {
        $( '.cpt-slider' ).each( function( index, element ) {
          let perPage = 3;
          let breakpoints = {
            1024: {
              perPage: 2,
              gap: '1.25rem',
            },
            768: {
              perPage: 1,
              gap: '1.25rem',
            },
          };

          if ( $( element ).attr( 'data-post-type' ) == 'll_soldier' ) {
            perPage = 5;
            breakpoints = {
              1024: {
                perPage: 3,
                gap: '1.25rem',
              },
              768: {
                perPage: 2,
                gap: '1.25rem',
              },
              480: {
                perPage: 1,
                gap: '1.25rem',
              },
            };
          } else if ( $( element ).attr( 'data-post-type' ) == 'll_primary_source' ) {
            perPage = 4;
            breakpoints = {
              1024: {
                perPage: 3,
                gap: '1.25rem',
              },
              768: {
                perPage: 2,
                gap: '1.25rem',
              },
              480: {
                perPage: 1,
                gap: '1.25rem',
              },
            };
          }

          const slider = new Splide( element, {
            type: 'carousel',
            gap: '1.5rem',
            perPage: perPage,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: breakpoints,
          } );

          slider.on( 'overflow', function( isOverflow ) {
            if ( !isOverflow ) {
              slider.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0,
                focus: 0,
              };
              $( element ).find( '.splide-arrows-area' ).hide();
            } else {
              $( element ).find( '.splide-arrows-area' ).show();
            }
          } );
          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'cpt-slider', COMPONENT );
} )( app );
